import { useQuery } from '@tanstack/react-query';
import { defineMessages, useIntl } from 'react-intl';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import EnumCacheService from '@/shared/services/EnumCacheService';
import { formatListValue } from '@/shared/components/FormattedListValue';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { EmployeeQueryKey } from './queryKey';
const messages = defineMessages({
    DefaultRoles: { id: 'DefaultRoles', defaultMessage: 'Default Roles' },
    CustomRoles: { id: 'CustomRoles', defaultMessage: 'Custom Roles' },
});
const CUSTOM_ROLE = 99;
const buildUserRoles = (tenantRoles, defaultRoles, intl) => [
    ...defaultRoles
        .map(x => ({
        role: x.key,
        label: formatListValue({ list: 'role', id: x.key, fallback: x.value, intl }),
        customRoleId: null,
        customRoleName: null,
        group: intl.formatMessage(messages.DefaultRoles),
    }))
        .sort(dynamicSort('role')),
    ...(tenantRoles || [])
        .map(x => ({
        role: CUSTOM_ROLE,
        label: x.name,
        customRoleId: x.id,
        customRoleName: x.name,
        group: intl.formatMessage(messages.CustomRoles),
    }))
        .sort(dynamicSort('label')),
];
export const useGetUserRoles = () => {
    const intl = useIntl();
    return useQuery([EmployeeQueryKey.UserRoles], async () => {
        const [tenantRoles, defaultRoles] = await Promise.all([
            api.base.get('/api/TenantRole').then(res => res.data),
            EnumCacheService.get('role'),
        ]);
        return buildUserRoles(tenantRoles, defaultRoles, intl);
    }, {
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
export default useGetUserRoles;
